import _extends from '@babel/runtime/helpers/esm/extends';
import { jsx } from '@emotion/react';
import { processTransformations, useCdnContext } from '@xsite-ui/common.cdn';
import React from 'react';
import { styled } from '@xsite-ui/common.style';
import identity from 'lodash.identity';
import pickBy from 'lodash.pickby';

function buildImageSrc(_ref) {
  var _ref$src = _ref.src,
      src = _ref$src === void 0 ? '' : _ref$src,
      _ref$cdn = _ref.cdn,
      cdnData = _ref$cdn.cdnData,
      isCloudinaryEnabled = _ref$cdn.isCloudinaryEnabled,
      cloudinaryConfig = _ref$cdn.cloudinaryConfig,
      cdnDomain = _ref$cdn.cdnDomain,
      _ref$transform = _ref.transform,
      transform = _ref$transform === void 0 ? {} : _ref$transform;
  return processTransformations({
    url: cdnData(src),
    transform: transform,
    isCloudinaryEnabled: isCloudinaryEnabled,
    cloudinaryConfig: cloudinaryConfig,
    cdnDomain: cdnDomain
  });
}
function buildImageSrcSet(_ref2) {
  var _ref2$transforms = _ref2.transforms,
      transforms = _ref2$transforms === void 0 ? [] : _ref2$transforms,
      urls = _ref2.urls,
      cdn = _ref2.cdn;
  return urls.map(function (url, index) {
    var transform = transforms[index] || {};
    var _transform$width = transform.width,
        width = _transform$width === void 0 ? '' : _transform$width;
    var src = buildImageSrc({
      src: url,
      transform: transform,
      cdn: cdn
    });
    return src.indexOf(' ') > 0 ? src : "".concat(src, " ").concat(width);
  }).join(', ');
}
/**
 * build image sizes
 *
 * @export buildSizes
 * @param {Array.<String>} [sizes=[]]
 * @returns {String} sizes values sepated with ', '
 */

function buildSizes() {
  var sizes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return sizes.join(', ');
}

var BackgroundImage = function BackgroundImage(_ref) {
  var _ref$src = _ref.src,
      src = _ref$src === void 0 ? '' : _ref$src,
      transform = _ref.srcTransform,
      _ref$as = _ref.as,
      tagName = _ref$as === void 0 ? 'div' : _ref$as,
      className = _ref.className,
      children = _ref.children,
      _ref$attributes = _ref.attributes,
      attributes = _ref$attributes === void 0 ? {} : _ref$attributes;
  var cdn = useCdnContext();
  var backgroundImageSrc = buildImageSrc({
    src: src,
    cdn: cdn,
    transform: transform
  });
  var BackgroundImageTag = tagName;
  return jsx(BackgroundImageTag, _extends({}, attributes, {
    className: className,
    css: {
      backgroundImage: "url('".concat(backgroundImageSrc, "')")
    }
  }), children);
};

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

var GenericImage = styled('img')(function (props) {
  return props.css;
});

function CdnImage(props) {
  var attrs = buildImageAttributes(props);
  var userAttributes = props.attributes,
      _props$css = props.css,
      css = _props$css === void 0 ? {} : _props$css,
      className = props.className;
  return /*#__PURE__*/React.createElement(GenericImage, _extends({
    css: css,
    className: className
  }, attrs, userAttributes));
}

var buildSrc = function buildSrc(_ref) {
  var src = _ref.src,
      cdn = _ref.cdn,
      transform = _ref.srcTransform;
  return buildImageSrc({
    src: src,
    cdn: cdn,
    transform: transform
  });
};

var buildSrcSet = function buildSrcSet(_ref2) {
  var srcSet = _ref2.srcSet,
      cdn = _ref2.cdn,
      transforms = _ref2.srcSetTransforms;
  return buildImageSrcSet({
    urls: srcSet || [],
    cdn: cdn,
    transforms: transforms
  });
};

var buildImageAttributes = function buildImageAttributes(props) {
  var attrs = {
    src: buildSrc(props),
    srcSet: buildSrcSet(props),
    sizes: buildSizes(props.sizes),
    alt: props.alt
  };

  if (props.lazy) {
    attrs.loading = 'lazy';
  }

  return _objectSpread2({}, pickBy(attrs, identity));
};

var Image = function Image(props) {
  if (!props.src) {
    return null;
  }

  var imageProps = _objectSpread2(_objectSpread2({}, props), {}, {
    cdn: useCdnContext()
  });

  return /*#__PURE__*/React.createElement(CdnImage, imageProps);
};

export { BackgroundImage, CdnImage, Image, buildImageSrc, buildImageSrcSet, buildSizes };
